// Configuration for the homepage featured carousel.
//
// Slide 1 is always the most recent published post. Slides 2 and 3 are "starred"
// posts, pinned from the WordPress editor by adding one of the tags below:
//   - a post tagged `featured-1` is always slide 2
//   - a post tagged `featured-2` is always slide 3
// Slot order comes from the tag, not from the publish date. Any slot left unfilled
// is backfilled with the next most recent post.

export const FEATURED_TAG_SLUGS = ['featured-1', 'featured-2'];

// How many slides the carousel aims to show (1 latest + 2 starred).
export const CAROUSEL_SLIDE_COUNT = 3;

// Auto-advance interval in milliseconds.
export const CAROUSEL_INTERVAL_MS = 7000;

// Horizontal drag distance (px) that counts as a swipe on touch devices.
export const CAROUSEL_SWIPE_THRESHOLD = 80;

// Slide and background crossfade durations, in seconds.
export const CAROUSEL_SLIDE_TRANSITION_S = 0.5;
export const CAROUSEL_FADE_TRANSITION_S = 0.7;
